<mat-card class="auth-block">
  <mat-card-content>
    <h1>Module not licensed</h1>
    <h4>Contact LBA Consulting for other informations</h4>
  </mat-card-content>
</mat-card>